import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, useTheme } from './context/ThemeContext';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { Analytics } from '@vercel/analytics/react';
import GlobalStyles from './styles/GlobalStyles';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import './App.css';
import LoadingFallback from './components/LoadingFallback';

// Lazy load page components for better performance
const HomePage = lazy(() => import('./pages/HomePage'));
const AboutPage = lazy(() => import('./pages/AboutPageUpdated'));
const ServicesPage = lazy(() => import('./pages/ServicesPage'));
const ServiceDetailPage = lazy(() => import('./pages/ServiceDetailPage'));
const PortfolioPage = lazy(() => import('./pages/PortfolioPage'));
const PortfolioDetailPage = lazy(() => import('./pages/PortfolioDetailPage'));
const ResourcesPage = lazy(() => import('./pages/ResourcesPage'));
const BlogDetailPage = lazy(() => import('./pages/BlogDetailPage'));
// const TestimonialsPage = lazy(() => import('./pages/TestimonialsPage')); // Commented out until we have testimonials
const ContactPage = lazy(() => import('./pages/ContactPage'));
const NotFoundPage = lazy(() => import('./pages/NotFoundPage'));
const LogoPreviewPage = lazy(() => import('./pages/LogoPreviewPage'));

function App() {
  return (
    <ThemeProvider>
      <AppWithTheme />
    </ThemeProvider>
  );
}

function AppWithTheme() {
  const { colors } = useTheme();
  
  return (
    <StyledThemeProvider theme={colors}>
      <GlobalStyles />
      <Analytics />
      <Router>
        <ScrollToTop />
        <div className="app">
          <Header />
          <main className="main-content">
            <Suspense fallback={<LoadingFallback />}>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/services" element={<ServicesPage />} />
                <Route path="/services/:id" element={<ServiceDetailPage />} />
                <Route path="/portfolio" element={<PortfolioPage />} />
                <Route path="/portfolio/:id" element={<PortfolioDetailPage />} />
                <Route path="/resources" element={<ResourcesPage />} />
                <Route path="/blog/:id" element={<BlogDetailPage />} />
                {/* Testimonials route commented out until we have testimonials to display */}
                {/* <Route path="/testimonials" element={<TestimonialsPage />} /> */}
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/logo-preview" element={<LogoPreviewPage />} />
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </Suspense>
          </main>
          <Footer />
        </div>
      </Router>
    </StyledThemeProvider>
  );
}

export default App;